<template>
  <div class="pagination">
    <div v-show="total > perPage" class="pagination-wrapper">
      <section class="flex justify-between px-2 py-3">
        <ul class="flex items-center">
          <li class="pr-4 md:block hidden">
            <component :is="hasPrev ? 'BaseLink' : 'span'" :url="pagLink(prevPage)">
              <div class="pagination__item arrow" :class="{'disabled': !hasPrev}">
                <BaseIcon
                  name="keyboard_arrow_left"
                  color="primary"
                />
              </div>
            </component>
          </li>
          <li v-show="hasFirst" class="pr-2">
            <BaseLink tag="a" :url="pagLink(1)">
              <div class="pagination__item">
                <span>
                  1
                </span>
              </div>
            </BaseLink>
          </li>
          <li v-show="hasFirst" class="pr-2">
            ...
          </li>
          <li v-for="(page,index) in pages" :key="index" class="pr-2">
            <BaseLink tag="a" :url="pagLink(page)">
              <div
                :class="{'active': current === page}"
                class="pagination__item"
              >
                <span>{{ page }}</span>
              </div>
            </BaseLink>
          </li>
          <li v-show="hasLast" class="pr-2">
            ...
          </li>
          <li v-show="hasLast" class="pr-2">
            <BaseLink tag="a" :url="pagLink(totalPages)">
              <div class="pagination__item">
                <span>
                  {{ totalPages }}
                </span>
              </div>
            </BaseLink>
          </li>
          <li class="pr-4 md:block hidden">
            <component :is="hasNext ? 'BaseLink' : 'span'" :url="pagLink(nextPage)">
              <div class="pagination__item arrow" :class="{'disabled': !hasNext}">
                <BaseIcon
                  name="keyboard_arrow_right"
                  color="primary"
                />
              </div>
            </component>
          </li>
        </ul>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaginationDisableJS',
  props: {
    current: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 0
    },
    perPage: {
      type: Number,
      default: 9
    },
    pageRange: {
      type: Number,
      default: 2
    },
    firstPageParameterless: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    pages () {
      const pages = []
      for (let i = this.rangeStart; i <= this.rangeEnd; i++) {
        pages.push(i)
      }
      return pages
    },
    rangeStart () {
      const start = this.current - this.pageRange
      return (start > 0) ? start : 1
    },
    rangeEnd () {
      const end = this.current + this.pageRange
      return (end < this.totalPages) ? end : this.totalPages
    },
    totalPages () {
      return Math.ceil(this.total / this.perPage)
    },
    nextPage () {
      return this.current + 1
    },
    prevPage () {
      return this.current - 1
    },
    pageNumbers () {
      return Math.ceil(this.pagination.total / this.pagination.per_page)
    },
    hasFirst () {
      return this.rangeStart !== 1
    },
    hasLast () {
      return this.rangeEnd < this.totalPages
    },
    hasPrev () {
      return this.current > 1
    },
    hasNext () {
      return this.current < this.totalPages
    }
  },
  methods: {
    changePage (page) {
      if (page > 0 && page <= this.totalPages) {
        this.$emit('pageChanged', page)
      }
    },
    pagLink (page) {
      return (this.firstPageParameterless && page === 1)
        ? this.localePath({ path: this.$route.path })
        : this.localePath(
          {
            params: this.$route.params,
            query: { ...this.$route.query, page_number: page }
          })
    }
  }
}
</script>

<style lang="scss" scoped>
.pagination {
  &-wrapper {
    @apply flex items-center space-x-2 justify-center;
  }
  &__item {
    @apply w-10 h-10 text__headline-4-xs--regular lg:text__body-2-md--regular flex items-center justify-center transition
    cursor-pointer hover:bg-primary-100 hover:text-primary rounded-2xl;
    &.arrow {
      @apply bg-primary-100;
    }
    &.active {
      @apply bg-primary text-white rounded-2xl;
    }
    &.disabled {
      @apply opacity-50 cursor-not-allowed;
    }
  }
}
</style>
